import { IconButton, Toolbar, Typography, styled } from "@mui/material";
import { Menu } from "@mui/icons-material";
import MuiAppBar from '@mui/material/AppBar';
import TextConstants from "../../constants/TextConstants";
import LayoutConstants from "../../constants/LayoutConstants";
import { Close } from "@mui/icons-material";

/** AppBar コンポーネント */
const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open' && prop !== 'sideMenuWidth'
})(({ theme, open, sideMenuWidth }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    // サイドメニューが開いているとき
    ...(open && {
        width: `calc(100% - ${sideMenuWidth}px)`,
        marginLeft: `${sideMenuWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    })
}))

/** ヘッダー コンポーネント */
const Header = ({ open, onClick }) => {
    return (
        <AppBar position="fixed" open={open} sideMenuWidth={LayoutConstants.SideMenuWidth}>
            <Toolbar>
                <IconButton
                    sx={{ mr: 2 }}
                    color="inherit"
                    edge="start"
                    onClick={onClick}>
                    {open ? <Close /> : <Menu />}
                </IconButton>
                <Typography variant="h6" noWrap component="div">
                    {TextConstants.Common.Title}
                </Typography>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
